import styled from "@emotion/styled"
import Divider, { DividerProps } from "@material-ui/core/Divider"
import React from "react"
import theme, { docketTheme } from "theme"

type TActiveProps = {
  isActive: boolean
}

const primary = theme.palette.primary.main
const { white } = theme.palette.common

const CustomDivider = (props: DividerProps) => <Divider {...props} />

export const StyledDivider = styled(CustomDivider)`
  background-color: ${({ theme }) => theme.palette.common.white};
  height: 0.2rem;
`

export const IconContainer = styled.div`
  text-align: center;
`

export const StyledNavigationLink = styled.a`
  text-decoration: none;
`

export const NavigationItemContainerBase = styled.div<TActiveProps>`
  display: flex;
  align-items: center;
  ${({ isActive }) => `
    background-color: ${isActive ? white : primary};
    color: ${isActive ? primary : white};
  `};
  svg {
    color: currentColor;
  }
`

export const NavigationItemContainer = styled(NavigationItemContainerBase)<TActiveProps>`
  height: 8.4rem;
`

export const StyledNavigationText = styled.div`
  font-size: ${docketTheme.typography.fontSize_md};
  line-height: 1.6rem;
  text-align: center;
`
